import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/success.png'
import _imports_1 from '../assets/congratulation.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-6f1a5b7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full flex justify-center paddingContainer" }
const _hoisted_2 = { class: "bg-white w-full border border-lightgrey flex flex-col items-center justify-center rounded infoContainer overflow-y-auto" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center topImage" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "w-44"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "w-84"
  })
], -1))
const _hoisted_5 = { class: "flex justify-center items-center mt-8 mb-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToOrgTab())),
          class: "btnprimary nextButton h-7 w-16 flex justify-center items-center"
        }, "Done")
      ])
    ])
  ]))
}